import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Typography,
  Grid,
  Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const ApproveRequestDialogAdmin = ({ open, handleClose, handleApprove }) => {

  const [remark, setRemark] = useState('');

  const [files, setFiles] = useState([]);

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleDeleteFile = (fileName) => {
    setFiles((prevFiles) => prevFiles.filter(file => file.name !== fileName));
  };

  const getFileIcon = (file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return <PictureAsPdfIcon />;
      case 'jpg':
      case 'jpeg':
      case 'png':
        return <ImageIcon />;
      case 'xls':
      case 'xlsx':
        return <InsertDriveFileIcon />;
      case 'doc':
      case 'docx':
        return <InsertDriveFileIcon />;
      default:
        return <AttachFileIcon />;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleApprove(remark, files);
    handleClose(); // Close the dialog after submission
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Approve Request</DialogTitle>
        <DialogContent sx={{ width: '30vw' }}>
          <DialogContentText>
            {
              `Please provide a remark for approving the request.`
            }
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Remark"
            type="text"
            fullWidth
            value={remark}
            onChange={handleRemarkChange}
            required
          />

          {/* <Typography variant="body2" mt={2}>
            Upload Supporting Documents
          </Typography>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            {files.map((file, index) => (
              <Grid item key={index}>
                <Chip
                  icon={getFileIcon(file)}
                  label={file.name}
                  onDelete={() => handleDeleteFile(file.name)}
                  deleteIcon={<CloseIcon />}
                />
              </Grid>
            ))}
          </Grid>
          <Button
            variant="text"
            component="label"
          >
            Add Files
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv,.pdf"
              hidden
              multiple
              onChange={handleFileChange}
            />
          </Button> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type='submit' color="primary">
            Approve
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ApproveRequestDialogAdmin;
